var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudyMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 23,
    height: 26,
    transform: "translate(-751.69 2404)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_83",
    "data-name": "Mask Group 83",
    transform: "translate(751.69 -2404)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "study",
    transform: "translate(-752 2405.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M19.231,0H3.954A3.967,3.967,0,0,0,0,3.967V19.3a3.967,3.967,0,0,0,3.954,3.967H19.231A3.967,3.967,0,0,0,23.184,19.3V3.967A3.964,3.964,0,0,0,19.231,0ZM.719,3.967A3.242,3.242,0,0,1,2.755.959,3.948,3.948,0,0,0,1.349,3.967v.2H.72v-.2Zm0,.924h.629V8.9H.719Zm0,4.734h.629v4.238H.719Zm0,4.959h.629v4.352H.719Zm.036,5.072h.629A3.938,3.938,0,0,0,2.753,22.3a3.238,3.238,0,0,1-2-2.647Zm6.884,2.886H5.3a3.233,3.233,0,0,1-3.2-2.885H3.352a1.743,1.743,0,1,0,0-.724H2.066V14.585H3.353a1.743,1.743,0,1,0,0-.725H2.066V9.623H3.353a1.742,1.742,0,1,0,0-.723H2.066V4.888H3.353a1.743,1.743,0,1,0,0-.725H2.066v-.2A3.245,3.245,0,0,1,5.3.721H7.638ZM4.1,18.936a1.019,1.019,0,1,1,0,.725h.943v-.725H4.1Zm0-5.072a1.019,1.019,0,1,1,0,.725h.943v-.722H4.1ZM4.1,8.9a1.019,1.019,0,1,1,0,.724h.943V8.907H4.1Zm0-4.734a1.02,1.02,0,1,1,0,.725h.943V4.174H4.1ZM22.466,19.3a3.245,3.245,0,0,1-3.234,3.246H8.357V.721H19.231a3.243,3.243,0,0,1,3.234,3.246V19.3ZM17.342,8.911h3.2v.723h-3.2v1.5h3.2v.721h-3.2v2.3h3.193L15.416,19.29,10.3,14.156h3.193v-2.3H10.372v-.722h3.119v-1.5H10.372V8.91h3.119V7.4H10.372V6.682H20.505V7.4H17.342V8.91h0Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyMaterial);
export default __webpack_public_path__ + "static/media/Study-material.236c87172aed4074b8c5b2baf414e3ba.svg";
export { ForwardRef as ReactComponent };